<template functional>
  <!-- 商品的基础信息【名称】【描述】 -->
  <div
    class="base-info"
    :style="(props.customStyle && props.customStyle.root) || {}"
  >
    <p
      class="name"
      :style="(props.customStyle && props.customStyle.name) || {}"
    >
      {{ props.name }}
      <span v-if="props.skuFormat">&nbsp;{{ props.skuFormat }}</span>
    </p>

    <!-- 预售押金提示信息【待确认是否需要】 -->
    <!-- <span v-if="props.packPriceMsg" class="deposit">
        {{ props.packPriceMsg }}
      </span> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    goodDesc: {
      type: String,
      default: ''
    },
    skuFormat: {
      type: String,
      default: ''
    },
    packPriceMsg: {
      type: String,
      default: ''
    },
    customStyle: {
      type: Object,
      default: () => {}
    },
    unit: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.name {
  height: 0.42rem;
  margin-top: 0.08rem;
  margin-bottom: 0.08rem;

  font-size: 0.3rem;
  line-height: 0.42rem;
  font-weight: bold;
  color: #262626;

  @include text-overflow-ellipsis-single;
}
.desc {
  height: 0.3rem;
  margin-top: 0.04rem;

  font-size: 0.22rem;
  line-height: 0.3rem;
  color: #8c8c8c;
  @include text-overflow-ellipsis-single;
}
.format-info {
  height: 0.3rem;
  margin-top: 0.04rem;

  font-size: 0.24rem !important;
  line-height: 0.3rem;
  color: #8c8c8c;
  @include text-overflow-ellipsis-single;
}
</style>
